"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _logging = require("@nerdwallet/logging");
var _default = (0, _logging.getLogger)('experiment');
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfbG9nZ2luZyIsInJlcXVpcmUiLCJfZGVmYXVsdCIsImdldExvZ2dlciIsImV4cG9ydHMiLCJkZWZhdWx0Il0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL2V4cGVyaW1lbnQvbG9nZ2VyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGdldExvZ2dlciB9IGZyb20gJ0BuZXJkd2FsbGV0L2xvZ2dpbmcnO1xuXG5leHBvcnQgZGVmYXVsdCBnZXRMb2dnZXIoJ2V4cGVyaW1lbnQnKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsSUFBQUEsUUFBQSxHQUFBQyxPQUFBO0FBQWdELElBQUFDLFFBQUEsR0FFakMsSUFBQUMsa0JBQVMsRUFBQyxZQUFZLENBQUM7QUFBQUMsT0FBQSxDQUFBQyxPQUFBLEdBQUFILFFBQUEifQ==